export const ERRORS_BLACKLIST = [
    'Network Error',
    'Loading chunk',
    'Loading CSS chunk',
    "Unexpected token '<'",
];
